module.exports = __webpack_public_path__ + "img/logo-solutions-klay.png";